<template>
  <div class="label">
    <p class="label-text">{{ text }}</p>
    <slot></slot>
  </div>
</template>

<script>
export default {
  name: 'Label',
  props: {
    text: {
      type: String,
      default: ''
    }
  }
};
</script>

<style lang="scss" scoped>
.label {
  margin-bottom: 24px;
  .label-text {
    margin-bottom: 24px;
    font-size: 26px;
    color: var(--text-color);
  }
}
</style>
